function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import './Filters.css';
import React from 'react';
import { canUseDOM, get } from '../../utils';
import { ReactComponent as BackArrow } from '../../resources/icons/arrow-left-noborder.svg';
import { filtersStylesLtr, filtersStylesRtl } from '../DynamicListingComponent/DynamicListingComponent';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import DropDown from './DropDown';
import Switch from './Switch';
import Checkbox from './Checkbox';
import DateRange from './DateRange';
import TextFilter from './TextFilter';
import { ANNUAL_FEE, totalParams } from './index';
import { tealiumMergeClickData, tealiumClickFunc } from '../../utils/tealium';
import RangeFilter from './RangeFilter';
import { DropdownResults } from './DropdownResults';
import ImageMultiSelect from './ImageMultiSelect';
import SortDropdown from './SortDropdown';
import NumberDropdown from './NumberDropdown';
import { qsToObject } from '../../utils/querystring';
import { useLocation, useHistory } from 'react-router-dom';
import { toggleLeftPanelOverflow } from '../atoms/InteractiveMap/utils/toggleLeftPanelOverflow';
const Filter = _ref => {
  let {
    fields,
    showLabel,
    resultsLabel,
    clearAllLabel,
    selectAllLabel,
    facets,
    params,
    nbHits,
    setListingFilter,
    facetsStats = {},
    // defaultFacets,
    resetFilterCallback,
    day,
    Cancel,
    FiltersCopy,
    lang,
    isTagPage,
    days,
    firstQuery,
    dictionary,
    imageDictionary,
    hits,
    defaultFacets,
    currentTypes,
    analytics,
    fullWidth = false,
    showClearAll = true,
    apllyFiltersOnChange = false,
    resetAllFiltersCallback,
    searchIndex = '',
    withMapModalView = false,
    dateRangeValue,
    getDateRangeValue,
    withMapConfig = false,
    skipFacetsFilter = false
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const filtersArray = get(fields, 'values');
  const filterWrapperRef = /*#__PURE__*/React.createRef();
  const [filterSubpanelText, setFilterSubpanelText] = React.useState('');
  const [clearAlllFilters, setclearAlllFilters] = React.useState(false);
  const [firstFilter, setFirstFilter] = React.useState(true);
  const [startPage, setStartPage] = React.useState(true);
  const [isSubmenuOpen, setSubmenuOpen] = React.useState(false);
  const [filtersCount, setFiltersCount] = React.useState(0);
  const [filtersValue, setFiltersValue] = React.useState({});
  const [totalFilters, settotalFilters] = React.useState(totalParams());
  const location = useLocation();
  let history = useHistory();
  const queryParams = qsToObject(location.search);
  React.useEffect(() => {
    filtersArray && filtersArray.map(el => {
      const preselectedTags = el.preselectedTags && el.preselectedTags.values.map(tag => get(tag, 'title.value') || get(tag, 'name'));
      const fieldNameItem = get(el, 'fieldNameItem.item.fieldName.value');
      const queries = queryParams[`${fieldNameItem}`];
      if (!queries) {
        setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [el.name]: {
            value: el.preselectedTags && el.preselectedTags.values.length !== 0 ? preselectedTags.join(',') : null,
            facet: fieldNameItem
          }
        }));
      } else {
        setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [el.name]: {
            value: queries,
            facet: fieldNameItem
          }
        }));
      }
    });
  }, []);
  React.useEffect(() => {
    let count = 0;
    for (let key in filtersValue) {
      const isFullFalseObj = () => {
        let isFullFalseObj = true;
        if (filtersValue[key].value !== null) {
          Object.values(filtersValue[key].value).forEach(el => {
            if (el) {
              isFullFalseObj = false;
            }
          });
        }
        return isFullFalseObj;
      };
      if (typeof filtersValue[key].value === 'string' ? filtersValue[key].value !== null : !isFullFalseObj()) {
        count = count + 1;
      }
    }
    setFiltersCount(count);
  }, [filtersValue]);
  const filterSubPanelToggle = function (toggle) {
    let closePanel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (filterWrapperRef.current) {
      if (toggle) {
        filterWrapperRef.current.classList.remove('filter__wrapper--submenu-open');
        setStartPage(true);
        setFirstFilter(true);
        setSubmenuOpen(false);

        // close common filter dropdown
        if (closePanel) {
          filterWrapperRef.current.classList.remove('filter__wrapper--open');
          document.body.classList.remove('filter__wrapper--open');
          toggleMapButton(false);
          setStartPage(true);
          setFirstFilter(true);
        }
      } else {
        filterWrapperRef.current.classList.add('filter__wrapper--submenu-open');
        setStartPage(false);
        setFirstFilter(false);
        setSubmenuOpen(true);
      }
      if (withMapModalView) {
        toggleLeftPanelOverflow(filterWrapperRef);
      }
    }
  };
  const clearKeyPressHandler = e => {
    if (e.which === 13 || e.which === 32) {
      e.preventDefault();
      clearAllCallback();
    }
  };
  const setFilter = function () {
    let firstFilter = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    setclearAlllFilters(false);
    setFirstFilter(firstFilter);
    setSubmenuOpen(false);
    setListingFilter();
    // setTimeout(() => {
    // getFilterValue()
    // settotalFilters(totalParams());
    // }, 10);
  };
  const getFilterValue = (fieldName, facet, filterValue) => {
    if (filterValue === null || filterValue === '' || filterValue.length === 0 || Object.keys(filterValue).length === 0) {
      setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldName]: {
          value: null,
          facet: facet
        }
      }));
    } else {
      setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
        [fieldName]: {
          value: filterValue,
          facet: facet
        }
      }));
    }
  };
  const clearAllCallback = () => {
    tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params));
    setclearAlllFilters(true);
    filterSubPanelToggle(true, false);
    setTimeout(() => {
      filtersArray && filtersArray.map(el => {
        const facetName = get(el, 'fieldNameItem.item.fieldName.value');
        setFiltersValue(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [el.name]: {
            value: null,
            facet: facetName
          }
        }));
      });
    }, 10);
    if (withMapConfig && getDateRangeValue) {
      getDateRangeValue({
        date: '',
        dateInit: undefined,
        formattedDate: ''
      });
    }
  };
  const controlBackBtn = isOpen => {
    setStartPage(isOpen);
  };
  const theme = get(sitecoreContext, 'themesOfPage');
  const themePrimary = get(theme, 'primary');
  const themePrimary__active = get(theme, 'primary_active');
  const submitAll = () => {
    const splitter = ';,;';
    const url = new URL(window.location.href);
    let newQueryArr = [];
    filtersArray.forEach(el => {
      filtersValue[el.name] = _objectSpread(_objectSpread({}, filtersValue[el.name]), {}, {
        fieldType: el.fieldTypeItem.item.fieldType.value
      });
    });
    for (let key in filtersValue) {
      if (typeof filtersValue[key].value === 'object' && filtersValue[key].value !== null && (filtersValue[key].fieldType === 'Dropdown' || filtersValue[key].fieldType === 'Dropdown Multi Select' || filtersValue[key].fieldType === 'Image Multi Select')) {
        if (filtersValue[key].value.length) {
          filtersValue[key].value.forEach(key => {
            newQueryArr.push(key);
          });
        } else {
          Object.keys(filtersValue[key].value).forEach(el => {
            if (filtersValue[key].value[el]) {
              const index = newQueryArr.indexOf(filtersValue[key].value[el]);
              if (index === -1) {
                newQueryArr.push(el);
              }
            }
          });
        }
        if (newQueryArr.length) {
          url.searchParams.set(filtersValue[key].facet, newQueryArr.join(splitter));
          history.push(`${url.search}${url.hash}`);
          setListingFilter();
          newQueryArr = [];
        }
      } else {
        if (filtersValue[key].value !== null) {
          url.searchParams.set(filtersValue[key].facet, `${filtersValue[key].value}`);
          history.push(`${url.search}${url.hash}`);
          setListingFilter();
        }
      }
    }
    filterSubPanelToggle(true);
    tealiumClickFunc(tealiumMergeClickData(analytics.filterShowResultsAnalytics, analytics.params));
  };
  const toggleMapButton = function () {
    let hide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    if (canUseDOM) {
      const button = document.querySelector('#interactive-map-toggle');
      if (button) {
        button.style.zIndex = hide ? '1' : '2';
      }
    }
  };
  const columnsClass = withMapModalView ? 'col-md-12' : filtersArray.length === 2 ? 'col-md-6' : 'col-md-4';
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    themePrimary: themePrimary,
    themePrimary__active: themePrimary__active,
    rtl: rtl
  }, /*#__PURE__*/React.createElement("div", {
    className: `filter__wrapper ${withMapModalView ? 'map-view' : ''}`,
    ref: filterWrapperRef
  }, /*#__PURE__*/React.createElement("div", {
    className: "row mob-filter-toggle"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }), /*#__PURE__*/React.createElement("div", {
    className: `${withMapModalView ? 'col-12 imfilters-padding' : 'col-12 col-md-4'}`
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => {
      document.body.classList.add('filter__wrapper--open');
      filterWrapperRef.current.classList.add('filter__wrapper--open');
      toggleMapButton(true);
      if (withMapModalView) {
        toggleLeftPanelOverflow(filterWrapperRef);
      }
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClickAnalytics, analytics.params));
    },
    className: "btn btn-secondary js-filters-trigger filter__toggle"
  }, FiltersCopy, " ", filtersCount > 0 && `(${filtersCount})`)), /*#__PURE__*/React.createElement("div", {
    className: "col-md-4"
  }), !withMapModalView && /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters-bottom-hr"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "filter"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__scroll"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    onClick: e => {
      filterSubPanelToggle(true, false);
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params), 'Cancel');
      if (withMapModalView) {
        toggleLeftPanelOverflow(filterWrapperRef);
      }
      e.stopPropagation();
    },
    className: "body-medium filter__header-back-link js-btn-close-panel"
  }, /*#__PURE__*/React.createElement(BackArrow, {
    className: "brand-icon"
  })), /*#__PURE__*/React.createElement("span", {
    className: `body-medium filter__header-links js-filters-close ${startPage ? 'cancel' : 'back'}`,
    onClick: () => {
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params), 'Back');
      if (startPage) {
        setStartPage(true);
        toggleMapButton(false);
        filterWrapperRef.current.classList.remove('filter__wrapper--open');
        document.body.classList.remove('filter__wrapper--open');
      } else {
        setStartPage(true);
        setFirstFilter(true);
      }
      if (withMapModalView) {
        toggleLeftPanelOverflow(filterWrapperRef);
      }
    }
  }, /*#__PURE__*/React.createElement(BackArrow, {
    className: "brand-icon"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filter__header-text body-medium"
  }, /*#__PURE__*/React.createElement("span", null, FiltersCopy, " "), /*#__PURE__*/React.createElement("span", {
    className: "js-opened-filter-label submenu__text"
  }, filterSubpanelText))), /*#__PURE__*/React.createElement("div", {
    className: "col-auto"
  }, /*#__PURE__*/React.createElement("span", {
    className: "body-medium filter__header-links",
    onClick: () => {
      clearAllCallback();
      tealiumClickFunc(tealiumMergeClickData(analytics.filterClearAllDateAnalytics, analytics.params), 'Clear all');
    }
  }, clearAllLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "filter__row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: `
                    ${withMapModalView ? 'col-md col-xl-12' : !fullWidth ? 'col-md col-xl-9 offset-xl-1' : 'col-md'}
                 `
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, filtersArray && filtersArray.map((filter, index) => {
    const filterName = get(filter, 'name');
    const fieldTypeItem = get(filter, 'fieldTypeItem.item.fieldType.value');
    const fieldNameItem = get(filter, 'fieldNameItem.item.fieldName.value');
    const fieldNamesItem = get(filter, 'fieldNameItems.items.0.fieldName.value');
    const item = !fieldNameItem ? get(filter, 'fieldNameItem.item', {}) : [];
    let fieldNameItemArray = !fieldNameItem ? Object.keys(item).map(name => get(item, `${name}.value`)) : [];
    let itemfacets;
    let defaultItemFacets;
    if (facets && defaultFacets) {
      itemfacets = facets[fieldNameItem] || facets[fieldNamesItem] || facets[fieldNameItem + 'RangeIndex'];
      defaultItemFacets = defaultFacets[fieldNameItem] || defaultFacets[fieldNamesItem] || defaultFacets[fieldNameItem + 'RangeIndex'];
    }
    if (fieldTypeItem === 'Dropdown') {
      return /*#__PURE__*/React.createElement(DropDown, {
        columnsClass: columnsClass,
        key: `${withMapModalView ? `map-view-${index}-${filterName}` : `${index}-${filterName}`}`,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facetsName: fieldNameItem,
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${withMapModalView ? `map-view-${index}-${filterName}` : `${index}-${filterName}`}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        keepOpenOnChange: true,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        withMapModalView: withMapModalView
      });
    } else if (fieldTypeItem === 'Dropdown Multi Select') {
      return /*#__PURE__*/React.createElement(DropDown, {
        columnsClass: columnsClass,
        key: `${withMapModalView ? `map-view-${index}-${filterName}` : `${index}-${filterName}`}`,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facets: itemfacets,
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: `${withMapModalView ? `map-view-${index}-${filterName}` : `${index}-${filterName}`}`,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        keepOpenOnChange: true,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        withMapModalView: withMapModalView
      });
    } else if (fieldTypeItem == 'Dropdown result') {
      return /*#__PURE__*/React.createElement(DropdownResults, {
        columnsClass: columnsClass,
        filteredOptions: hits ? hits : [],
        label: fieldNameItem
      });
    } else if (fieldTypeItem === 'Text') {
      return /*#__PURE__*/React.createElement(TextFilter, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        params: params,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        rtl: rtl,
        analytics: analytics,
        fullWidth: filtersArray.filter(f => get(f, 'fieldNameItems.items', []).some(i => get(i, 'fieldName.value', '').includes('venueMeetingRooms'))),
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Range') {
      return /*#__PURE__*/React.createElement(RangeFilter, {
        columnsClass: columnsClass,
        key: `${index}-${filterName}`,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        queryString: fieldNameItem === 'maxDelegates' ? fieldNameItem : ANNUAL_FEE,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsStats: facetsStats && facetsStats[ANNUAL_FEE],
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        hits: hits || [],
        analytics: analytics,
        setStartPage: controlBackBtn,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Range Multi Select') {
      return /*#__PURE__*/React.createElement(RangeFilter, {
        columnsClass: columnsClass,
        key: `${index}-${filterName}`,
        fields: filter,
        queryString: fieldNameItem === 'maxDelegates' ? fieldNameItem : ANNUAL_FEE,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        facets: itemfacets,
        facetsStats: facetsStats && facetsStats[ANNUAL_FEE],
        facetsName: fieldNameItem,
        defaultFacets: defaultItemFacets,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        hits: hits || [],
        isMultiSelect: true,
        analytics: analytics,
        getFilterValue: getFilterValue
      });
    } else if (fieldTypeItem === 'Switch') {
      return /*#__PURE__*/React.createElement(Checkbox, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        setFilter: setFilter,
        facetsName: fieldNameItem,
        fields: filter,
        wrapperToggle: filterSubPanelToggle,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        getFilterValue: getFilterValue,
        withMapModalView: withMapModalView
      });
    } else if (fieldTypeItem === 'Toggle Multi Select') {
      return /*#__PURE__*/React.createElement(Switch, {
        key: `${index}-${filterName}`,
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        facetsName: fieldNameItem,
        selectAllLabel: selectAllLabel,
        firstQuery: firstQuery,
        fields: filter,
        day: day,
        days: days,
        wrapperToggle: filterSubPanelToggle,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        isTagPage: isTagPage,
        dictionary: dictionary,
        firstFilter: firstFilter,
        analytics: analytics,
        getFilterValue: getFilterValue,
        rtl: rtl,
        resetAllFiltersCallback: resetAllFiltersCallback,
        withMapModalView: withMapModalView,
        skipFacetsFilter: skipFacetsFilter
      });
    } else if (fieldTypeItem === 'Toggle Single Select') {
      return /*#__PURE__*/React.createElement(Switch, {
        key: `${index}-${filterName}`,
        facets: itemfacets,
        defaultFacets: defaultItemFacets,
        selectAllLabel: selectAllLabel,
        facetsName: fieldNameItem,
        firstQuery: firstQuery,
        fields: filter,
        day: day,
        days: days,
        wrapperToggle: filterSubPanelToggle,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        isTagPage: isTagPage,
        dictionary: dictionary,
        firstFilter: firstFilter,
        analytics: analytics,
        getFilterValue: getFilterValue,
        rtl: rtl,
        resetAllFiltersCallback: resetAllFiltersCallback,
        withMapModalView: withMapModalView,
        skipFacetsFilter: skipFacetsFilter
      });
    } else if (fieldTypeItem === 'Date Range' || fieldTypeItem === 'Deals Date Range') {
      return /*#__PURE__*/React.createElement(DateRange, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        clearAlllFilters: clearAlllFilters,
        fields: filter,
        clearAllCallback: resetFilterCallback,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        facetsName: fieldNameItemArray,
        clearAllLabel: clearAllLabel,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        lang: lang,
        analytics: analytics,
        setStartPage: controlBackBtn,
        submenuHelper: isSubmenuOpen,
        getFilterValue: getFilterValue,
        withMapModalView: withMapModalView,
        withMapConfig: withMapConfig,
        dateRangeValue: dateRangeValue,
        getDateRangeValue: getDateRangeValue
      });
    } else if (fieldTypeItem === 'Date') {
      return /*#__PURE__*/React.createElement(DateRange, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        clearAlllFilters: clearAlllFilters,
        fields: filter,
        clearAllCallback: resetFilterCallback,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        facetsName: fieldNameItemArray,
        clearAllLabel: clearAllLabel,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        lang: lang,
        analytics: analytics,
        setStartPage: controlBackBtn,
        submenuHelper: isSubmenuOpen,
        getFilterValue: getFilterValue,
        withMapModalView: withMapModalView,
        withMapConfig: withMapConfig,
        dateRangeValue: dateRangeValue,
        getDateRangeValue: getDateRangeValue
      });
    } else if (fieldTypeItem === 'Sort') {
      return /*#__PURE__*/React.createElement(SortDropdown, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facets: get(filter, 'fieldNameItems.items'),
        facetsName: get(filter, 'fieldNameItems.items', []).map(f => get(f, 'fieldName.value', '')),
        dictionary: dictionary,
        defaultFacets: get(filter, 'fieldNameItems.items'),
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback,
        searchIndex: searchIndex
      });
    } else if (fieldTypeItem === 'Number') {
      return /*#__PURE__*/React.createElement(NumberDropdown, {
        key: `${index}-${filterName}`,
        columnsClass: columnsClass,
        fields: filter,
        showLabel: showLabel,
        resultsLabel: resultsLabel,
        clearAllLabel: clearAllLabel,
        selectAllLabel: selectAllLabel,
        facetsName: fieldNameItem,
        dictionary: dictionary,
        firstFilter: firstFilter,
        nbHits: nbHits,
        firstQuery: firstQuery,
        indexDropDown: index,
        setFilter: setFilter,
        wrapperToggle: filterSubPanelToggle,
        setSubpanelLabel: setFilterSubpanelText,
        clearAlllFilters: clearAlllFilters,
        analytics: analytics,
        hideShowButton: apllyFiltersOnChange,
        getFilterValue: getFilterValue,
        resetAllFiltersCallback: resetAllFiltersCallback
      });
    } else if (fieldTypeItem === 'Image Multi Select') {
      return /*#__PURE__*/React.createElement(ImageMultiSelect, {
        filter: filter,
        hits: hits,
        params: params,
        facets: itemfacets,
        dictionary: dictionary,
        analytics: analytics,
        imageDictionary: imageDictionary,
        facetsName: fieldNamesItem,
        setFilter: setFilter,
        clearAlllFilters: clearAlllFilters,
        getFilterValue: getFilterValue
      });
    } else {
      return /*#__PURE__*/React.createElement("div", {
        key: index
      });
    }
  }))), filtersArray.length > 1 && showClearAll && /*#__PURE__*/React.createElement("div", {
    className: "col-md-auto col-lg-2 d-flex justify-content-end align-items-end filter__col-clear"
  }, /*#__PURE__*/React.createElement("button", {
    onKeyPress: clearKeyPressHandler,
    onClick: clearAllCallback,
    className: "body-medium link-clear filter-panel__row-clear btn--reset"
  }, clearAllLabel)))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: `col-md ${currentTypes && currentTypes[0] == 'type:Video Details Page' ? 'col-xl-11' : 'col-xl-11'}  offset-xl-1`
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-12"
  }, /*#__PURE__*/React.createElement("div", {
    className: "filters-bottom-hr"
  })))))), /*#__PURE__*/React.createElement("div", {
    className: "filter__btn-row"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: submitAll,
    className: "btn btn-primary js-filters-close"
  }, showLabel, " ", resultsLabel)))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    themePrimary,
    themePrimary__active
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", {
    className: `${commonStyles} ${stylesInteractiveMapModal}  ${rtl ? filtersStylesRtl : filtersStylesLtr} ${rtl ? rtlStyles : ''}  ${rtl ? rtlStylesInteractiveMapModal : ''} `
  }, children);
};
export default Filter;
const commonStyles = "caod502";
const stylesInteractiveMapModal = "s1bg7ezf";
const rtlStylesInteractiveMapModal = "r37wpvb";
const rtlStyles = "r1lklj7f";